/* eslint-disable import/no-extraneous-dependencies */
import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import rootreducers from './modules/RootReducer';

const middleware = applyMiddleware(thunk);

const store = createStore(rootreducers, composeWithDevTools(middleware));

export default store;
